<template>
  <div class="input-group plan_item time">
    <div class="mb30">
      <div class="flex ">
        <div class="mr-2 relative">
          <div class='toggle-btns flex w_100 py-4'>
            <div class='btn w_100 text-center p-2 pointer border'
                 :class='{active: is_departure}'
              @click='is_departure=true'
            >Departure date</div>
            <div class='btn w_100 text-center p-2 pointer border'
                 :class='{active: !is_departure}'
              @click='is_departure=false'
            >Arrival date</div>

          </div>
          <DateRangePicker
              class="select_date_range"
              :timePicker="true"
              :timePickerIncrement="10"
              :minDate="disabledDate"
              :singleDatePicker="true"
              @update='onApply'
              v-model="activePickerModel">
            <template
                v-slot:input
                style="min-width: 350px;"
            >{{ displayDate }}</template>
          </DateRangePicker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import 'vue-range-component/dist/vue-range-slider.css'
import moment from 'moment';
export default {
  name: 'DateSelect',
  components: {
    DateRangePicker
  },
  props: {
    reset_all: {
      type: Boolean,
      default: false
    },
    route_line: {
      type: Object,
    },
    initial_is_departure: {
      type: Boolean,
      default: true,
    },
    picker_dates: {
      type: Object,
      default: () => ({
        startDate: new Date(),
        endDate: null
      })
    },
    start_date_user_set: {
      type: Boolean,
      default: false,
    },
    end_date_user_set: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let startDate = new Date();
    return {
      state :{
        disabledDates : {
          to: new Date(new Date().getTime() - 86400000)
        },
      },
      disabledDate : new Date().toISOString().slice(0, 10),
      is_departure: this.initial_is_departure,
      start_date: '',
      end_date: '',
      startDateUserSet: this.start_date_user_set,
      endDateUserSet: this.end_date_user_set,
      pickerDates: {
        startDate,
        endDate: null,
      },
    }
  },
  methods: {
    async emitSelection() {
      await this.$emit('selectDates', {
        pickerDates: {
          startDate: this.pickerDates.startDate,
          endDate: this.pickerDates.endDate,
          is_departure: this.is_departure,
        },
        is_departure: this.is_departure,
        startDateUserSet: this.startDateUserSet,
        endDateUserSet: this.endDateUserSet,
      });
    },
    roundPickerTenMinutes(date) {
      const newDate = new Date(date);
      newDate.setMinutes(Math.floor(newDate.getMinutes() / 10) * 10);
      return newDate;
    },
    formatDisplayDates() {
      if (this.pickerDates.startDate) {
        this.start_date = moment(this.pickerDates.startDate).format('DD-MM-YYYY, HH:mm');
      } else {
        this.start_date = '';
      }
      if (this.pickerDates.endDate) {
        this.end_date = moment(this.pickerDates.endDate).format('DD-MM-YYYY, HH:mm');
      } else {
        this.end_date = '';
      }
    },
    async onApply(val) {
      let picked = new Date(val.startDate);

      const minutes = moment(val.startDate).minute();
      if (minutes % 10 !== 0) {
        picked = this.roundPickerTenMinutes(val.startDate);
      }

      if (this.is_departure) {
        this.pickerDates.startDate = picked;
        this.startDateUserSet = true;
      } else {
        this.pickerDates.endDate = picked;
        this.endDateUserSet = true;
      }

      const currentTime = new Date().getTime();
      const arrivalTime = new Date(
        this.pickerDates.endDate || this.pickerDates.startDate || picked,
      ).getTime();
      if (arrivalTime < currentTime) {
        this.is_departure = true;
      }

      this.formatDisplayDates();
      await this.emitSelection();
    }
  },
  async mounted() {
    this.formatDisplayDates();
  },
  computed: {
    defaultDate() {
      return moment(new Date()).format('DD-MM-YYYY, HH:mm')
    },
    displayDate() {
      if (this.is_departure) {
        return this.start_date || this.defaultDate;
      }
      return this.end_date || this.defaultDate;
    },
    activePickerModel: {
      get() {
        const activeDate = this.is_departure
          ? (this.pickerDates.startDate || new Date())
          : (this.pickerDates.endDate || this.pickerDates.startDate || new Date());
        return {
          startDate: activeDate,
          endDate: activeDate,
        };
      },
      set(val) {
        if (!val) {
          return;
        }
        const picked = val.startDate || val.endDate;
        if (!picked) {
          return;
        }
        if (this.is_departure) {
          this.pickerDates.startDate = new Date(picked);
        } else {
          this.pickerDates.endDate = new Date(picked);
        }
      },
    },
  },
  watch: {
    initial_is_departure(newValue) {
      this.is_departure = newValue;
    },
    start_date_user_set(newValue) {
      this.startDateUserSet = newValue;
    },
    end_date_user_set(newValue) {
      this.endDateUserSet = newValue;
    },
    picker_dates: {
      handler(newDates) {
        if (newDates && newDates.startDate) {
          this.pickerDates = {
            startDate: new Date(newDates.startDate),
            endDate: newDates.endDate ? new Date(newDates.endDate) : null,
          };
          this.formatDisplayDates();
        }
      },
      deep: true,
      immediate: true
    },
    is_departure: {
      async handler() {
        await this.emitSelection();
      },
    },
    reset_all() {
      this.is_departure = true;
      this.startDateUserSet = false;
      this.endDateUserSet = false;
      this.pickerDates = {
        startDate: new Date(),
        endDate: null,
      };
      this.formatDisplayDates();
    }
  }
}
</script>
<style scoped lang="scss">
.btn {
  transition: .2s;
  padding: 10px;
  &.active {
    color: #1FBC2F;
    background: #fff;
    font-weight: bold;
    border: 1px solid #1FBC2F;
    transition: .2s;
  }
}
</style>
